export const GET_TODAY_EARNING_REQUEST = "GET_TODAY_EARNING_REQUEST";
export const GET_TODAY_EARNING_SUCCESS = "GET_TODAY_EARNING_SUCCESS";
export const GET_TODAY_EARNING_FAIL =    "GET_TODAY_EARNING_FAIL";

export const ADD_TODAY_EARNING_REQUEST = "ADD_TODAY_EARNING_REQUEST";
export const ADD_TODAY_EARNING_SUCCESS = "ADD_TODAY_EARNING_SUCCESS";
export const ADD_TODAY_EARNING_FAIL = "ADD_TODAY_EARNING_FAIL";
export const ADD_TODAY_EARNING_RESET = "ADD_TODAY_EARNING_RESET";

export const FULLDAY_EARNING_REQUEST = "FULLDAY_EARNING_REQUEST";
export const FULLDAY_EARNING_SUCCESS = "FULLDAY_EARNING_SUCCESS";
export const FULLDAY_EARNING_FAIL = "FULLDAY_EARNING_FAIL";
export const FULLDAY_EARNING_RESET = "FULLDAY_EARNING_RESET";

export const UPDATE_TODAY_EARNING_REQUEST = "UPDATE_TODAY_EARNING_REQUEST";
export const UPDATE_TODAY_EARNING_SUCCESS = "UPDATE_TODAY_EARNING_SUCCESS";
export const UPDATE_TODAY_EARNING_FAIL = "UPDATE_TODAY_EARNING_FAIL";
export const UPDATE_TODAY_EARNING_RESET = "UPDATE_TODAY_EARNING_RESET";

export const DELETE_TODAY_EARNING_REQUEST = "DELETE_TODAY_EARNING_REQUEST";
export const DELETE_TODAY_EARNING_SUCCESS = "DELETE_TODAY_EARNING_SUCCESS";
export const DELETE_TODAY_EARNING_FAIL = "DELETE_TODAY_EARNING_FAIL";
export const DELETE_TODAY_EARNING_RESET = "DELETE_TODAY_EARNING_RESET";

export const DAY_EARNING_REQUEST = "DAY_EARNING_REQUEST";
export const DAY_EARNING_SUCCESS = "DAY_EARNING_SUCCESS";
export const DAY_EARNING_FAIL = "DAY_EARNING_FAIL";

export const MONTHLY_EARNING_REQUEST = "MONTHLY_EARNING_REQUEST";
export const MONTHLY_EARNING_SUCCESS = "MONTHLY_EARNING_SUCCESS";
export const MONTHLY_EARNING_FAIL = "MONTHLY_EARNING_FAIL";

export const YEARLY_EARNING_REQUEST = "YEARLY_EARNING_REQUEST";
export const YEARLY_EARNING_SUCCESS = "YEARLY_EARNING_SUCCESS";
export const YEARLY_EARNING_FAIL = "YEARLY_EARNING_FAIL";

export const GET_MONTHLY_HISTORY_REQUEST = "GET_MONTHLY_HISTORY_REQUEST";
export const GET_MONTHLY_HISTORY_SUCCESS = "GET_MONTHLY_HISTORY_SUCCESS";
export const GET_MONTHLY_HISTORY_FAIL = "GET_MONTHLY_HISTORY_FAIL";

export const GET_COMPLETE_DATA_REQUEST = "GET_COMPLETE_DATA_REQUEST";
export const GET_COMPLETE_DATA_SUCCESS = "GET_COMPLETE_DATA_SUCCESS";
export const GET_COMPLETE_DATA_FAIL = "GET_COMPLETE_DATA_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS"; 